import React from 'react'
import { Grid } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs, { Dayjs } from 'dayjs'
import { ONLY_DATE_FORMAT } from '../../constants/global'

interface Props {
  startDate?: string | undefined
  endDate?: string | undefined
  onChange: (
    startDate?: string | undefined,
    endDate?: string | undefined,
  ) => void
  disableFuture?: boolean
  gap?: number
}

const DateRangePicker = ({
  startDate,
  endDate,
  onChange,
  disableFuture = false,
  gap = 2,
}: Props) => {
  const handleDateChange =
    (type: 'startDate' | 'endDate') => (date: Dayjs | null) => {
      const newDateRange = {
        startDate,
        endDate,
        [type]:
          type === 'startDate'
            ? date?.startOf('day').format()
            : date?.endOf('day').format(),
      }
      onChange(newDateRange.startDate, newDateRange.endDate)
    }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid container spacing={gap}>
        <Grid item xs={6} lg={6}>
          <DatePicker
            format={ONLY_DATE_FORMAT}
            disableFuture={disableFuture}
            label="เลือกวันที่เริ่มต้น"
            value={startDate ? dayjs(startDate) : null}
            onChange={handleDateChange('startDate')}
            sx={{ width: '100%' }}
            slotProps={{
              actionBar: {
                actions: ['clear'],
              },
            }}
            localeText={{
              clearButtonLabel: 'ล้างข้อมูล',
            }}
          />
        </Grid>
        <Grid item xs={6} lg={6}>
          <DatePicker
            format={ONLY_DATE_FORMAT}
            disableFuture={disableFuture}
            label="เลือกวันที่สิ้นสุด"
            value={endDate ? dayjs(endDate) : null}
            onChange={handleDateChange('endDate')}
            sx={{ width: '100%' }}
            slotProps={{
              actionBar: {
                actions: ['clear'],
              },
            }}
            localeText={{
              clearButtonLabel: 'ล้างข้อมูล',
            }}
          />
        </Grid>
      </Grid>
    </LocalizationProvider>
  )
}

export default DateRangePicker
